module.exports = __webpack_public_path__ + "static/img/kjtb1-8-1.ade9bcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kjtb1-8-1.png
// module id = 930
// module chunks = 0